<template>
  <v-textarea
    v-bind="$attrs"
    v-on="$listeners">
    <template #message="{ message }">
      {{ $t(message) }}
    </template>
    <template #append>
      <slot name="append"></slot>
    </template>
  </v-textarea>
</template>

<script>
export default {
  name: 'CTextArea',
  inheritAttrs: false,
};
</script>
